"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigEnum = void 0;
var ConfigEnum;
(function (ConfigEnum) {
    ConfigEnum[ConfigEnum["LocalPort"] = 8082] = "LocalPort";
})(ConfigEnum || (exports.ConfigEnum = ConfigEnum = {}));
